import type {
  ButtonVariant,
  IconCircleVariant,
  IconName,
} from '@storyblok/design-system'

type ModalOption = {
  buttonVariant: ButtonVariant
  type: string
  icon: IconName
  iconVariant: IconCircleVariant
}

type ModalOptions = {
  delete: ModalOption
  confirm: ModalOption
  confirmNeutral: ModalOption
  caution: ModalOption
  info: ModalOption
}

const CONFIRMATION_MODAL = Object.freeze({
  delete: {
    buttonVariant: 'danger',
    type: 'delete',
    icon: 'trash-2',
    iconVariant: 'danger',
  },
  confirm: {
    buttonVariant: 'primary',
    type: 'confirm',
    icon: 'circle-help',
    iconVariant: 'success',
  },
  confirmNeutral: {
    buttonVariant: 'primary',
    type: 'confirm-neutral',
    icon: 'gem',
    iconVariant: 'neutral',
  },
  caution: {
    buttonVariant: 'caution',
    type: 'caution',
    icon: 'triangle-alert',
    iconVariant: 'warning',
  },
  info: {
    buttonVariant: 'info',
    type: 'info',
    icon: 'info',
    iconVariant: 'info',
  },
} as ModalOptions)

export default CONFIRMATION_MODAL
